import clsx from 'clsx'
import { MoveToFolder, TrashDelete, XClose } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { BUTTON_COLORS, BUTTON_SIZES, BUTTON_VARIANTS } from '@/components/button/constants'

interface BulkActionBarProps {
  selectedCount: number
  onMove: () => void
  onDelete: () => void
  onClearSelection: () => void
}

/**
 * BulkActionBar
 *
 * Action bar that appears when items are selected.
 * Shows selected count and bulk action buttons.
 */
export function BulkActionBar({ selectedCount, onMove, onDelete, onClearSelection }: BulkActionBarProps) {
  const hasSelection = selectedCount > 0
  const tabIndex = hasSelection ? undefined : -1

  return (
    <div
      className={clsx('flex items-center gap-[13px] py-2 px-4 md:px-0', !hasSelection && 'invisible pointer-events-none [&_button]:transition-none')}
      aria-hidden={!hasSelection || undefined}
    >
      <Button
        onClick={onClearSelection}
        variant={BUTTON_VARIANTS.PLAIN}
        color={BUTTON_COLORS.SECONDARY}
        size={BUTTON_SIZES.SM}
        trailingIcon={<XClose className="h-4 w-4" />}
        tabIndex={tabIndex}
      >
        {selectedCount} item{selectedCount > 1 ? 's' : ''} selected
      </Button>

      <Button
        onClick={onDelete}
        variant={BUTTON_VARIANTS.OUTLINED}
        color={BUTTON_COLORS.DESTRUCTIVE}
        size={BUTTON_SIZES.SM}
        trailingIcon={<TrashDelete className="h-4 w-4" />}
        tabIndex={tabIndex}
      >
        Delete
      </Button>

      <Button
        onClick={onMove}
        variant={BUTTON_VARIANTS.OUTLINED}
        color={BUTTON_COLORS.NEUTRAL}
        size={BUTTON_SIZES.SM}
        trailingIcon={<MoveToFolder className="h-4 w-4" />}
        tabIndex={tabIndex}
      >
        Move
      </Button>
    </div>
  )
}
